import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import { ConcessionsPaymentCopy } from '../../../helper/textcopy/policies.text';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'concessions-payment-policy',
  templateUrl: './concessions-payment.component.html',
})
export class ConcessionsPaymentComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;
  textCopy = ConcessionsPaymentCopy;

  proofDocuments: Array<{ value: string; text: string }> = [];

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnInit() {
    this.setProofDocuments();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setProofDocuments() {
    this.proofDocuments = [
      { value: 'y', text: 'copy of both sides of cheque' },
      { value: 'n', text: 'bank statement' },
      { value: 'y', text: 'account number, sort code and cheque number' },
      { value: 'n', text: 'code number on back of cheque' },
    ];
  }
  onSelectProofDocument(document) {
    document.value = document.value === 'n' ? 'y' : 'n';
  }

  setSelectedValues() {
    this.proofDocuments[0].value = this.policiesAnswers['5_1_1_1'];
    this.proofDocuments[1].value = this.policiesAnswers['5_1_1_2'];
    this.proofDocuments[2].value = this.policiesAnswers['5_1_1_3'];
    this.proofDocuments[3].value = this.policiesAnswers['5_1_1_4'];
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '5_1_1_1', description: this.proofDocuments[0].value },
      { id: '5_1_1_2', description: this.proofDocuments[1].value },
      { id: '5_1_1_3', description: this.proofDocuments[2].value },
      { id: '5_1_1_4', description: this.proofDocuments[3].value },
    ];

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
